import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { MoltiplicatoreDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class MoltiplicatoreApiClient extends BaseCRUDApiClient<MoltiplicatoreDto> {
  baseUrl = this.config.apiEndpoint + '/moltiplicatore';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  swap(moltiplicatoreDareId: number, moltiplicatoreAvereId: number) {
    return this.http.put<MoltiplicatoreDto[]>(
      `${this.baseUrl}/swap/${moltiplicatoreDareId}/${moltiplicatoreAvereId}`,
      null
    );
  }
}
